<template>
<div>
  <div class="columns">
    <div class="column">
      <p class="has-text-danger">{{ index }}. {{ scraper.type | ucwords }} Scraper</p>
      <p class="has-text-weight-bold">Handler</p>
      <p class="has-text-grey">{{ scraper.handler }}</p>

      <p>
        <source-lookup-grammar :payload="scraper.scraper_payload"/>
      </p>

      <p class="has-text-grey" v-if="scraper.scraper_payload.children.length">
        If the first lookup yields results. The following subsequent lookups will run.
      </p>
      <p v-for="(child, index) in scraper.scraper_payload.children" :key="index">
        <child-source-grammar 
          :parent="scraper.scraper_payload" 
          :payload="child"
        />
      </p>
    </div>
    <div class="column is-narrow">
      <router-link 
        :to="{
          name: 'edit-secondary-source-scraper',
          params: {
            scraper: scraper.id
          }
        }"
        class="button is-small">
        Edit
      </router-link>
      <action-button 
        @click="deleteSecondaryScrapers"
        class="is-small">
        Delete
      </action-button>
    </div>
  </div>
</div>  
</template>
<script>
export default {

  props: {
    index: {
      type: Number
    },
    scraper: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    async deleteSecondaryScrapers() {
      if(await this.$confirm({
        title: 'Delete Secondary Scraper',
        message: 'Deleting this secondary scraper will remove all scrapers in this pipeline as they are fed to each other.'
      })) {
        this.$store.dispatch('attributeType/deleteSecondaryScrapers').then(() => {
          this.$toast.success('Secondary Scraper deleted')
        }).catch(error => {
          this.$toast.error('Whoops, something went wrong')
        })
      }
    }
  }
}
</script>